export default {"src":"/_next/static/media/openFile.f7605b46.svg","height":34,"width":34};